// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__vYfwe","content":"Footer_content__-y8xY","section":"Footer_section__LJ8vp"};